import { render } from "./updateUserDataCompleteOnboardingMutation.vue?vue&type=template&id=8350e846"
import script from "./updateUserDataCompleteOnboardingMutation.vue?vue&type=script&lang=js"
export * from "./updateUserDataCompleteOnboardingMutation.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projekte/Seminarplattform/lernplattform-holistic-institut/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__